import {Input as BaseInput, InputProps} from '../../control';
import {ElementStatus, useFormElementContext} from '../../form';
import {join} from '../../utils';
import {ChangeEvent, useCallback, useMemo} from 'react';
import {omit} from 'underscore';

import styles from './input.module.less';

export type Props = Omit<InputProps, 'value' | 'onChange' | 'disabled'> & {
	showCharactersLeft?: boolean;
	classNameSuccess?: string;
	classNameError?: string;
};

export function Input({classNameSuccess, classNameError, ...props}: Props): JSX.Element {
	const {status, setValue, validateOnBlur, value, setRef} = useFormElementContext({
		string: true,
		number: true,
	}, Input);
	const isStatusValid = status === ElementStatus.valid;
	const isStatusInvalid = status === ElementStatus.invalid;
	const className = join(
		styles.formControlInput,
		isStatusInvalid && styles.error,
		isStatusInvalid && classNameError,
		isStatusValid && styles.success,
		isStatusValid && classNameSuccess,
		props.className,
	);
	const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value), [setValue]);
	const onBlur = useCallback(() => validateOnBlur(), [validateOnBlur]);
	const charactersLeft = useMemo(() => props.maxLength - value.length, [props.maxLength, value]);
	return (
		<>
			<BaseInput
				{...omit(props, 'showCharactersLeft')}
				value={value}
				ref={setRef}
				onChange={onChange}
				onBlur={onBlur}
				aria-invalid={status === ElementStatus.invalid}
				disabled={status === ElementStatus.disabled}
				className={className}
			/>
			{props.showCharactersLeft &&
				<div className={styles.maxCharBlock}>
					{`${charactersLeft} characters left (${props.maxLength}max)`}
				</div>
			}
		</>
	);
}

export default Input;
